















































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import AdminDeviceTypeService from '../../services/admin.devicetype.service';
import AddManufacturer from '@/components/devicetypes/AddManufacturer.vue';
import AddDeviceModel from '@/components/devicetypes/AddDeviceModel.vue';
import AddChipManufacturer from '@/components/devicetypes/AddChipManufacturer.vue';
import FileUpload from '@/components/FileUpload.vue';
import { Route } from 'vue-router';
import { Cropper } from 'vue-advanced-cropper';
import '../../classes/blob.image.convert';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    Dialog,
    AddManufacturer,
    AddDeviceModel,
    AddChipManufacturer,
    FileUpload,
    Cropper,
  },
})
export default class AdminDeviceTypeSettings extends Vue {
  private menuItems: any[] = [
    { name: 'Device', items: [
        { id: 0, title: 'Details', path: 'deviceTypeDetails'},
        { id: 1, title: 'Catalogue Details', path: 'catalogueDetails'},
      ],
    },
    { name: 'Editors', items: [
        { id: 2, title: 'Mapping Function', path: 'mappingFunctionEditor'},
        { id: 3, title: 'Downlink Function', path: 'downlinkFunctionEditor' },
        { id: 4, title: 'Data Schema',  path: 'dataSchemaEditor' },
        { id: 5, title: 'Configuration Profiles', path: 'configurationEditor' },
        { id: 6, title: 'Event Rules', path: 'ruleEditor' },
        { id: 7, title: 'Interface Functions', path: 'interfaceEditor' },
        { id: 8, title: 'Modbus Registers', path: 'modbusEditor' },
        { id: 9, title: 'Barcode Function', path: 'barcodeFunctionEditor' },
      ],
    },
  ];
  private deviceType: any = null;
  private isManufacturerDialogVisible: boolean = false;
  private isChipManufacturerDialogVisible: boolean = false;
  private isDeviceModelDialogVisible: boolean = false;
  private activeList: object[] = [];
  private activeIndex: number | null = null;
  private clicked: any = {};
  private snackbar: boolean = false;

  @Getter private activeOrganisationId: any;
  @Getter private hasPermission: any;

  private logo: Blob | null = null;
  private DEFAULT_V3_MAPPING_FUNCTION = `(data) => { // data is a buffer\n\treturn {\n\t\tmsgtype: [{\n\t\t}]\n\t}\n}`;

  @Watch('$route.path', {immediate: true})
  private onRouteChange() {
    this.getSelected();
  }

  private getSelected() {
    const activeList = this.menuItems.filter((menu: any) => {
      if (menu.items.some((m: any) => this.$route.name!.includes(m.path))) {
        return menu;
      }
    });
    this.activeList = activeList[0].items;
    this.clicked = this.activeList.find((a: any) => this.$route.name!.includes(a.path));
    this.activeIndex = this.clicked.id;
  }

  private async mounted() {
    this.getSelected();

    await this.initDeviceType();
  }

  private get menu() {
    const editorMenu = this.menuItems.find((m) => m.name === 'Editors');
    editorMenu.items = editorMenu.items.filter((menuItem: any) => {
      return !(menuItem.path === 'modbusEditor' && this.deviceType.lan_protocol !== 'Modbus');
    });

    const mainMenu = this.menuItems.find((m) => m.name === 'Device');
    return [{name: 'Device', items: mainMenu.items}, {name: 'Editors', items: editorMenu.items}];
  }

  private async initDeviceType() {
    if (this.$route.params.id === 'new') {
      this.deviceType = {
        manufacturer_id: null,
        name: '',
        bearer: '',
        device_model: {},
        slug: '',
        is_public: true,
        configuration: {},
        schema_fields: [],
        configuration_profiles: [],
        sigfox_certificate_id: null,
        require_local_addresses: false,
        modbus_register_configs: [],
      };
    } else {
      this.deviceType = await AdminDeviceTypeService.getSystemDeviceType(Number(this.$route.params.id));
    }
  }

  private async saveDeviceType(deviceType: any, logoData: any = {}) {
    if (this.$route.params.id !== 'new') {
      this.deviceType.id = this.$route.params.id;
    }
    if (!deviceType.device_model_id || !deviceType.chip_manufacturer_id) {
      throw new Error('Please select a device model and chip manufacturer');
    }
    if (!deviceType.bearer) {
      throw new Error('Please select a radio technology');
    }
    if (deviceType.bearer === 'lora' && (!deviceType.device_class || !deviceType.lorawan_version)) {
      throw new Error('Please select a LoRa device class and version');
    }
    if (!deviceType.name) {
      throw new Error('Please set a name');
    }
    let resp = null;
    if (deviceType.is_public) {
     deviceType.organisation_id = null;
    }
    let deviceTypeId: number;
    if (this.deviceType.id) {
      resp = await AdminDeviceTypeService.updateSystemDeviceType(this.deviceType.id, deviceType);
    } else {
      resp = await AdminDeviceTypeService.saveSystemDeviceType(deviceType);
    }
    if (!resp.id) {
      return;
    }
    this.snackbar = true;

    deviceTypeId = resp.id;

    if (logoData.saveImage) {
      if (logoData.croppedLogo || logoData.logo) {
        await AdminDeviceTypeService.uploadDeviceLogo(deviceTypeId, logoData.croppedLogo || (await logoData.logo!.toPNG()));
        if (logoData.croppedLogo) {
          logoData.showCropper = false;
          this.logo = logoData.croppedLogo;
          // this.$forceUpdate();
        }
      } else {
        await AdminDeviceTypeService.removeDeviceLogo(deviceTypeId);
      }
    }
    if (this.deviceType.id) {
      await this.initDeviceType();
    } else if (this.$route.params.id === 'new') {
      this.$router.push({name: 'deviceTypeDetails', params: {id: deviceTypeId.toString()}});
    }
  }

  private async beforeRouteUpdate(to: Route, from: Route, next: any) {
    this.deviceType.id = to.params.id;
    await this.initDeviceType();
    next();
  }

  private async createSystemConfigurationProfile(profile: any) {
    let resp = null;
    if (this.deviceType.id) {
      resp = await AdminDeviceTypeService.createSystemConfigurationProfile(this.deviceType.id, profile);
      if (!resp.id) {
        return;
      }
      await this.saveDeviceType(this.deviceType);
    }
  }

  private async updateSystemConfigurationProfile(profile: any) {
    let resp = null;
    if (this.deviceType.id) {
      resp = await AdminDeviceTypeService.updateSystemConfigurationProfile(this.deviceType.id, profile.id, profile);
      if (!resp.id) {
        return;
      }
      await this.saveDeviceType(this.deviceType);
    }
  }

  private async deleteSystemConfigurationProfile(profile: any) {
    if (this.deviceType.id) {
      const resp = await AdminDeviceTypeService.deleteSystemConfigurationProfile(this.deviceType.id, profile.id);
      await this.saveDeviceType(this.deviceType);
    }
  }

  private showManufacturerDialog() {
    this.isManufacturerDialogVisible = true;
  }

  private showChipManufacturerDialog() {
    this.isChipManufacturerDialogVisible = true;
  }

  private showDeviceModelDialog() {
    this.isDeviceModelDialogVisible = true;
  }
}
